/*
 * File: CustomErrorMessage.tsx
 * Project: a-a
 * File Created: Wednesday, 23rd October 2024 1:57:47 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 16th September 2025 10:32:05 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import { Snackbar } from '@mui/material';
import Slide, { SlideProps } from '@mui/material/Slide';
import { styled } from '@mui/material/styles';
import zeplinColor from '../../../theme/Color';

type CustomAlertProp = {
  open: boolean;
  message: React.ReactNode;
  handleClose: () => void;
  error?: boolean;
};

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction='up' />;
}

const CustomBar = styled(Snackbar)<{ error?: string }>(({ theme, error }) => ({
  '& .MuiPaper-root.MuiPaper-elevation': {
    borderRadius: 14,
    backgroundColor: error === 'true' ? zeplinColor.Error : zeplinColor.BasicBlack,

    minWidth: '162px',
    minHeight: 56,
    padding: '12px 24px',
  },
  '& .MuiSnackbarContent-message': {
    padding: 0,
  },
}));

const CustomAlert = ({ open, message, handleClose, error = false }: CustomAlertProp) => {
  return (
    <CustomBar
      open={open}
      slots={{ transition: SlideTransition }}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={message}
      onClose={handleClose}
      error={error ? 'true' : 'false'}
    />
  );
};

export default CustomAlert;
